import React, { useCallback } from "react";
import { Message } from "../../types/conversations";
import { MessageItem } from "./MessageItem";

interface MessagesListProps {
  messages: Message[];
  isLoadingMore: boolean;
  onScroll: () => void;
  messagesContainerRef: React.RefObject<HTMLDivElement>;
  messagesEndRef: React.RefObject<HTMLDivElement>;
}

export const MessagesList: React.FC<MessagesListProps> = ({
  messages,
  isLoadingMore,
  onScroll,
  messagesContainerRef,
  messagesEndRef,
}) => {
  const setContainerRef = useCallback(
    (el: HTMLDivElement | null) => {
      const prev = (
        messagesContainerRef as React.MutableRefObject<HTMLDivElement | null>
      ).current;
      if (prev && prev !== el) {
        prev.removeEventListener("scroll", onScroll);
      }
      (
        messagesContainerRef as React.MutableRefObject<HTMLDivElement | null>
      ).current = el;
      if (el) {
        el.addEventListener("scroll", onScroll);
      }
    },
    [onScroll, messagesContainerRef],
  );

  return (
    <div
      ref={setContainerRef}
      className="conversations-scroll messages-list-optimized flex-1 min-h-0 overflow-y-auto px-3 py-3 space-y-2 md:px-4 md:py-4 md:space-y-3"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h40v40H0z' fill='%23f0f0f0' fill-opacity='0.05'/%3E%3C/svg%3E\")",
        WebkitOverflowScrolling: "touch",
        overscrollBehavior: "contain",
      }}
    >
      {isLoadingMore && (
        <div className="flex justify-center py-2">
          <div className="w-6 h-6 border-2 border-purple-400 border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      {messages.map((message, index) => {
        // Converter timestamps para Date se necessário e validar
        const prevTimestamp = messages[index - 1]?.timestamp;
        const currentTimestamp = message.timestamp;

        const prevDate =
          prevTimestamp instanceof Date
            ? prevTimestamp
            : new Date(prevTimestamp);
        const currentDate =
          currentTimestamp instanceof Date
            ? currentTimestamp
            : new Date(currentTimestamp);

        const showDate =
          index === 0 ||
          (!isNaN(prevDate.getTime()) &&
            !isNaN(currentDate.getTime()) &&
            prevDate.toDateString() !== currentDate.toDateString());

        return (
          <MessageItem key={message.id} message={message} showDate={showDate} />
        );
      })}
      <div ref={messagesEndRef} />
    </div>
  );
};
